var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrensaL5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 20,
    viewBox: "0 0 71 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2644_462)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2644_462",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6467 0H0V20H70.6467V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2644_462)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.438 14.6037V10.4934L59.6721 14.6037H62.438ZM54.1885 16.4123L61.8965 4.97107H66.2003V19.7199H62.4478V17.5921H57.6605L56.2194 19.7199H48.0859V4.97107H51.8577V16.4123H54.1885ZM62.5638 3.99426L65.2718 0H66.2003V3.99426H62.5638ZM7.77573 4.69035C12.3213 4.69035 15.5709 8.23973 15.5709 12.3404C15.5709 16.4507 12.3406 20.0001 7.7564 20.0001C3.11417 20.0001 0 16.3153 0 12.5241C0 11.5473 0.135399 10.4448 0.58028 9.37127C1.35399 7.466 3.64609 4.69035 7.77573 4.69035ZM7.8338 16.6925C10.5031 16.6925 11.799 14.2553 11.799 12.3694C11.799 10.4545 10.5031 8.0076 7.7854 8.0076C5.17417 8.0076 3.76215 10.2417 3.76215 12.3113C3.76215 14.5841 5.29989 16.6925 7.8338 16.6925ZM16.0642 4.97111H19.836V10.5128H24.0817V4.97111H27.8535V19.7199H24.0817V13.8204H19.836V19.7199H16.0642V4.97111ZM35.0391 16.4123L42.7375 4.97111H47.0606V19.7199H43.3081V17.5825H38.5208L37.0895 19.7199H28.9075V4.97111H32.6697V16.4123H35.0391ZM40.5228 14.6037H43.2985V10.4935L40.5228 14.6037ZM70.6493 15.3485H67.2446V4.97111H70.6493V15.3485ZM70.6493 19.7199H67.2446V16.3253H70.6493V19.7199Z",
    fill: "#E71F64"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2644_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.6667,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrensaL5);
export default __webpack_public_path__ + "static/media/Prensa-L-5.e4d9e6aa102e949657030eece37b7ef9.svg";
export { ForwardRef as ReactComponent };